import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Auth } from "aws-amplify";
import "bootstrap/dist/css/bootstrap.min.css";

import { awsConfig } from "./awsConfig";
import "./styles/main.scss";
import App from "./App";

Auth.configure(awsConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
